import {connect} from "react-redux";
import {default as List} from "./users";
import {actions} from "./logic/actions";


function mapDispatchProps(dispatch){
    return {
        loadList:() => dispatch(actions.LOAD_LIST.send())
    };
}
export const UserList = connect((state) => ({
    users:state.users.filterList,
    listStatus:state.users.listStatus,
}), mapDispatchProps)(List);